import { z } from 'zod';
import { Validation } from '@mews/framework';
import { updateSchema as commonUpdateSchema } from '../common/schemas';

export const schema = z.object({
    mewsBiWorkspaceId: Validation.String.Empty.default(''),
    enterpriseIds: z.array(z.string()).min(1),
    userIds: z.array(z.string()).min(1),
});

export type FormValues = z.infer<typeof schema>;

export const updateSchema = schema.merge(commonUpdateSchema);

export type UpdateFormValues = z.infer<typeof updateSchema>;
export type UpdateFormValuesInput = z.input<typeof updateSchema>;
